import { camelCase } from 'lodash';
import { FieldValue, FieldValueType } from 'api/tasks';
import { FilterableField } from 'components/organisms/tasks/fields';

const nativeTaskColumns = [
  'project',
  'projectPhaseId',
  'assignee',
  'startDate',
  'dueDate',
  'timeEntryMinutes',
  'atRisk',
  'completedAt',
  'responsible',
  'createdBy',
  'createdAt',
  'jiraIntegration',
];

export const withValidCustomTaskFields = (
  accountId: number,
  field: FilterableField,
) => {
  if (![1, 3, 207, 5140, 123, 127, 700].includes(accountId)) {
    return field;
  }

  const duplicateWithNative = nativeTaskColumns.includes(
    camelCase(field.fieldName),
  );
  const isIdAlreadyAppended = field.fieldName?.includes(
    field.fieldId.toString(),
  );
  const isCustomField = field.userCreated && field.customField;
  const transformedField = `${camelCase(field.fieldName)}${field.fieldId}`;

  return {
    ...field,
    fieldName:
      isCustomField && duplicateWithNative && !isIdAlreadyAppended
        ? transformedField
        : field.fieldName,
  };
};

export const withValidCustomFieldsForData = (
  field: FieldValue<FieldValueType>,
) => {
  const duplicateWithNative = nativeTaskColumns.includes(
    camelCase(field.fieldName),
  );
  const isIdAlreadyAppended = field.fieldName?.includes(
    field.fieldId.toString(),
  );
  const transformedField = `${camelCase(field.fieldName)}${field.fieldId}`;

  const isCustomField = field.userCreated && field.customField;

  return {
    ...field,
    fieldName:
      isCustomField && duplicateWithNative && !isIdAlreadyAppended
        ? transformedField
        : field.fieldName,
  };
};
